import React, { useMemo } from "react"

const useRemoveHtmlTags = (str) => {
  return useMemo(() => {
    return str.replace(/(<([^>]+)>)/ig, "")
  }, [])
}

export default useRemoveHtmlTags
